/**
 * components/Logo.jsx
 * Official Hyring brand mark and wordmark.
 */

export function LogoMark({ size = 32, rounded = true }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect width="105" height="105" rx={rounded ? 20 : 0} fill="url(#hyring-grad-linear)" />
      <path
        d="M42.4891 86.5307C53.2823 83.9171 61.4065 79.1444 66.6075 75.2945C70.9825 72.0561 72.0663 65.8855 68.9735 61.4064C68.9482 61.3697 68.9226 61.333 68.8969 61.2962C63.0336 52.9231 53.3604 49.5237 53.3604 49.5237C53.3604 49.5237 65.2694 47.6476 80.7109 57.8273C81.7461 54.8232 82.3169 51.603 82.3169 48.2468C82.3169 31.3504 68.0848 17.7782 50.9549 18.8636C45.7415 19.1939 40.8737 20.9198 36.7237 23.6657C33.9145 25.5245 32.1721 28.6627 32.1658 32.0312C32.1612 34.4875 32.8546 37.4948 35.1383 40.7561C41.0015 49.1292 50.6748 52.5286 50.6748 52.5286C50.6748 52.5286 38.9442 54.3809 23.671 44.4555C23.6086 44.9419 23.5558 45.4312 23.5179 45.9244C22.5577 58.445 29.4383 69.4638 39.7607 74.6077C41.0247 75.2376 42.2172 76.0181 43.1862 77.0455C45.1357 79.1126 46.8802 82.6009 42.4891 86.5307ZM54.7175 59.9267C57.9822 58.1928 62.0343 59.4337 63.7683 62.6984C65.5022 65.9631 64.2612 70.0153 60.9965 71.7493C57.7318 73.4832 53.6796 72.2422 51.9457 68.9775C50.2118 65.7128 51.4527 61.6606 54.7175 59.9267ZM49.3177 42.1256C46.053 43.8595 42.0008 42.6186 40.2669 39.3538C38.533 36.0891 39.774 32.0369 43.0387 30.303C46.3034 28.5691 50.3556 29.8101 52.0895 33.0748C53.8234 36.3395 52.5824 40.3917 49.3177 42.1256Z"
        fill="white"
      />
      <defs>
        <linearGradient id="hyring-grad-linear" x1="0" y1="52.5" x2="105" y2="52.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF7009" />
          <stop offset="1" stopColor="#FF0663" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Wordmark({ size = 18, color = '#fff' }) {
  return (
    <span
      style={{
        fontFamily: "'Archivo', -apple-system, sans-serif",
        fontSize: size,
        fontWeight: 600,
        letterSpacing: '-0.02em',
        color,
        lineHeight: 1,
      }}
    >
      hyring
    </span>
  );
}

export function LogoLockup({ size = 30, gap = 10, color = '#fff' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap }}>
      <LogoMark size={size} />
      <Wordmark size={Math.round(size * 0.6)} color={color} />
    </div>
  );
}
